import {
  useCallback, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateUserData } from '~/_shared/components/accountSettings/useUpdateUserData';
import { normalizeWhitespace } from '~/_shared/utils/text/text.helpers';
import { ModalType } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import { userGetDataRequest } from '~/store/userData/userData.actionCreators';
import {
  useUserCurrentClientSelector, useUserDataSelector,
} from '~/store/userData/userData.selectors';

export const useShowMissingUserInfoModal = () => {
  const { firstName, lastName, isReady } = useUserDataSelector();
  const currentClient = useUserCurrentClientSelector();
  const { openModal } = useModal(ModalType.MissingUserInfo);
  const { changeUserData } = useUpdateUserData();
  const dispatch = useDispatch();

  const handleSubmit = useCallback(async (newFirstName: string, newLastName: string) => {
    const result = await changeUserData({ first_name: normalizeWhitespace(newFirstName), last_name: normalizeWhitespace(newLastName) });
    if (!result.error) {
      dispatch(userGetDataRequest());
    }
    else {
      throw new Error(result.error?.message ?? 'Unknown error');
    }
  }, [changeUserData, dispatch]);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    if ((!normalizeWhitespace(firstName) || !normalizeWhitespace(lastName)) && currentClient?.migrationDone !== false) {
      openModal({ firstName, lastName, onSubmit: handleSubmit });
    }
  }, [firstName, lastName, isReady, currentClient, openModal, handleSubmit]);
};
